import { I18N } from '@/app'
import { TypeGuards, createForm, getValidator, yup } from '@codeleap/common'

export const aboutJobForm = () => {
  return createForm('aboutJob', {
    department: {
      label: I18N.t('form.label.department'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      type: 'select',
      validate: yup.string().required()
    },
    seniority: {
      type: 'select',
      label: I18N.t('form.label.seniority'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      validate: yup.string().required()
    },
    organization: {
      type: 'select',
      label: I18N.t('form.label.organisation'),
      placeholder: I18N.t('form.placeholder.selectOne'),
      validate: (val, formValues) => {
        let value = val
        if (!TypeGuards.isNumber(val)) {
          value = val?.id
        }

        const validator = getValidator(yup.number().required(I18N.t('form.validations.required')))

        return validator(value, formValues)
      }
    }
  })
}
